// Registers src/service-worker.js (built by CRA's InjectManifest) in
// production only. A new build activates on the next launch: we do not force
// a reload while someone may be listening.
export function register() {
  if (process.env.NODE_ENV !== 'production') return;
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  if (publicUrl.origin !== window.location.origin) return;

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    navigator.serviceWorker.register(swUrl).then((registration) => {
      registration.onupdatefound = () => {
        const installing = registration.installing;
        if (!installing) return;
        installing.onstatechange = () => {
          if (installing.state === 'installed' && navigator.serviceWorker.controller) {
            // New shell ready; it takes over when every tab/app instance closes.
            window.dispatchEvent(new CustomEvent('byopdf:sw-update-ready'));
          }
        };
      };
    }).catch((error) => {
      console.warn('Service worker registration failed:', error);
    });
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => registration.unregister()).catch(() => {});
  }
}
